import CloudFunctionError, { CloudFunctionErrorType } from './CloudFunctionError.js'
import { httpsCallable } from 'firebase/functions'
import { functions } from './Firebase.js'
import { CloudFunction } from '../../../pure-js/enums/CloudFunction.js'

export const callFunction = (cloudfunction: CloudFunction, req?: any) => {
  return httpsCallable(
    functions,
    cloudfunction
  )(req)
    .then(({ data }) => Promise.resolve(console.log('Success', cloudfunction)).then(() => data))
    .catch(onErrorFactory(cloudfunction)) as Promise<any>
}

const onErrorFactory = (functionName: CloudFunction) => (err: CloudFunctionErrorType) => {
  err.message = `Error in ${functionName}: ${err.message}`
  console.log('Error', err.message)
  return Promise.reject(new CloudFunctionError(err, functionName))
}
